/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BlueskyBrandIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABWklEQVR4nO1TuUoDURQ9ikvn0llpp6UfYuMHKAYrLRTxBwbMvZNgpwTB5RcUMaWInSCIo03qgFUKKwXF7ch7GRMyzry8acQiB251z3LvW4Ae/heEe1A+QVhFibPeOsM1mqa24gp4hpJxvUNY8BiqYLk/OuPhGWDIX1CuOfjrMaetMVs4BA8JMqH8hHI+hTsH4UcKv+4KuEsR0E4VcrrF2+LMr23bW9+6AqoZAYTwBvscRMABKK8zecpTV0DFISSEGyhyswtnNzsg5KJTrHyMy8VZyA5orn/ZxYCOurAeTuxwGMpVKE+gjKB8cRiaXgThMYQrCDgEL5Q4DuERhK8eU5uQQwQcgzfMqvmP59zPPGB/x9fXjhdyZSu99wayz3eDs1STkEsQLud//0lscwLKWsIgsi/EfDbhfaJXs5pcKHPUXrSyYc+3zMlWr8ip+J4aEB4g4Eg+8x7+Et+1eRqisVr+/AAAAABJRU5ErkJggg==)
 */
export const BlueskyBrandIcon = ({size = 'md', width, height, ...props}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill="#0085FF"
        d="M6.9 5.08C8.97 6.64 11.2 9.8 12 11.5v4.5c0-.1-.04.01-.12.24-.42 1.27-2.08 6.19-5.88 2.25-2-2.07-1.07-4.14 2.57-4.77-2.09.36-4.43-.23-5.07-2.55-.19-.66-.5-4.77-.5-5.33 0-2.77 2.41-1.9 3.9-.77Zm10.2 0C15.03 6.64 12.8 9.8 12 11.5v4.5c0-.1.04.01.12.24.42 1.27 2.08 6.19 5.88 2.25 2-2.07 1.07-4.14-2.57-4.77 2.09.36 4.43-.23 5.07-2.55.18-.66.5-4.77.5-5.33 0-2.77-2.41-1.9-3.9-.77Z"
      />
    </svg>
  );
};
